


































































































































































import Vue from "vue";

import AppFooter from "./components/app/AppFooter.vue";
import AppHeader from "./components/app/AppHeader.vue";
import AppMenu from "./components/app/AppMenu.vue";
import AppNav from "./components/app/AppNav.vue";
import AppNavItem from "./components/app/AppNavItem.vue";
import AppSearch from "./components/app/AppSearch.vue";

import AppLayout from "./layouts/Default.vue";

import mainMenu from "./menus/main";
import orgMenu from "./menus/org";
import userMenu from "./menus/user";

import routes from "./router/routes";

import { mapState } from "vuex";

export default Vue.extend({
  components: {
    AppLayout,
    AppFooter,
    AppHeader,
    AppMenu,
    AppNav,
    AppNavItem,
    AppSearch
  },
  data() {
    return {
      menus: {
        mainMenu: {
          hidden: true
        },
        orgMenu: {
          hidden: true
        },
        userMenu: {
          hidden: true
        }
      },
      nav: {
        show: false
      },
      route: "",
      scrollingDown: false,
      search: {
        show: false
      }
    };
  },

  computed: {
    footer(): object {
      return {
        text: "This is the footer."
      };
    },
    header: {
      get(): object {
        return {
          title: this.$route.params.page || process.env.VUE_APP_TITLE,
          show: this.$store.state.auth.user.uid
        };
      },
      set() {
        return
      }
    },

    ...mapState(["auth", "user"])
  },

  methods: {
    showContactDetails() {
      // @ts-ignore
      this.$buefy.snackbar.open({
          message: `
            <p>Tel: 0333 016 5252</p>
            <p>Email: info@time-lapse-systems.co.uk</p>
            <p>Website: <a href="https://www.time-lapse-systems.co.uk" target="blank">www.time-lapse-systems.co.uk</a></p>
          `,
          type: 'is-primary',
          position: 'is-top-right',
          actionText: 'Close',
          indefinite: true
      })
    },
    scrollDown(value) {
      this.scrollingDown = value
    },
    toggleNav() {
      this.$set(this.nav, 'show', !this.nav.show)
      // this.nav.show = !this.nav.show;
      this.search.show = false;
    },
    toggleSearch() {
      this.search.show = !this.search.show;
      if (this.search.show == true) {
        // @ts-ignore
        const searchInput = document.getElementById("search-input");
        const focusSearch = setInterval(() => {
          if (searchInput) {
            searchInput.focus();
            clearInterval(focusSearch);
          }
        }, 50);
      }
      this.nav.show = false;
    }
  },

  updated() {
    if (this.route != this.$route.path) {
      this.nav.show = false;
      this.search.show = false;
      this.route = this.$route.path;
    }
  },
  created() {
    //@ts-ignore
    this.$firebase.performance()

    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.$store.dispatch("auth/setUser", user);
        if (this.$auth.currentUser) {
          const authUser = this.$auth.currentUser
          this.$analytics.identify(authUser.uid, {email: authUser.email, displayName: authUser.displayName})
          
          this.$auth.currentUser.getIdTokenResult().then(async result => {
            await this.$store.dispatch("auth/setToken", result);

            if (result.claims.client) {
              this.$db.collection('clients').doc(result.claims.client).get().then(doc => {
                if (doc.exists) {
                  this.$store.dispatch('setClient', {_id: doc.id, ...doc.data()})
                }
              })
            }

            if (this.$route.path == "/auth") {
              if (typeof this.$route.query.redirect == "string") {
                this.$router.push(decodeURI(this.$route.query.redirect));
              } else {
                this.$router.push("/");
              }
            }

            let navItems = [] as any[]
            if (this.$store.state.auth.token) {
              navItems = mainMenu.items.filter(link => {
                return link.link === '/' || this.$store.state.auth.token.claims.super || this.$store.state.auth.token.claims.permissions.indexOf(`read:${link.resource}`) > -1
              })

            }

            this.$set(this.menus, "mainMenu", {items: navItems, hidden: true});
            this.$set(this.menus, "orgMenu", {...orgMenu, hidden: true});
            this.$set(this.menus, "userMenu", {...userMenu, hidden: true});
          });
        }

        this.$db
          .collection("schemas")
          .get()
          .then(snapshot => {
            const schemas = {};
            snapshot.forEach(doc => {
              schemas[doc.id] = doc.data();
            });
            this.$store.dispatch("setSchemas", schemas);
          }).catch(err => {
            if (err.code === "unavailable") {
              alert("Unable to connect to the database due to a poor internet connection. You may wait for the connection to be restored, or try refreshing the page.")
            }
            window.console.error(err)
          });

        this.$db
          .collection("users")
          .doc(user.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              this.$store.dispatch("updateUser", { id: doc.id, ...doc.data() });
            }
          }).catch(err => {
            if (err.code === "unavailable") {
              alert("Unable to connect to the database due to a poor internet connection. You may wait for the connection to be restored, or try refreshing the page.")
            }
            window.console.error(err)
          });

      } else {
        this.$store.dispatch("auth/signOut");
        const route = routes.find(route => route.path == this.$route.matched[this.$route.matched.length -1].path);
        if (route && route.requireAuth) {
          this.$router.push(`/auth?redirect=${this.$route.path}`);
        } else if (!route) {
          this.$router.push("/auth");
        }
      }
    });
  }
});
